
        <!-- data table -->
        <div 
        *ngIf="!isMobile"
        matSort 
        class="table-div"
        (matSortChange)="sortData($event)">
            <table class="table table-striped">
                <thead>
                    <tr>

                        <th 
                        scope="col"
                        mat-sort-header="wallet">
                            Territorial Partner
                        </th>

                        <th 
                        *ngIf="currentTab == 'dealer'"
                        scope="col"
                        mat-sort-header="dealer">
                            Dealer
                        </th>

                        <th 
                        *ngIf="currentTab == 'subdealer'"
                        scope="col"
                        mat-sort-header="subdealer">
                            Subdealer
                        </th>

                        <!-- <th 
                        scope="col"
                        mat-sort-header="transaction_id">
                            Transaction Id
                        </th> -->
                        
                        <th 
                        scope="col"
                        mat-sort-header="source">
                            Source
                        </th>
                        
                        <th 
                        scope="col"
                        mat-sort-header="source_user_lavel">
                            Source User Lavel
                        </th>

                        <th 
                        scope="col"
                        mat-sort-header="target">
                            Target
                        </th>

                        <th 
                        scope="col"
                        mat-sort-header="target_user_level">
                            Target User Level
                        </th>

                        <th 
                        scope="col"
                        mat-sort-header="amount">
                            Amount
                        </th>

                        <th 
                        scope="col"
                        mat-sort-header="transaction_date">
                            Transaction Date & Time
                        </th>

                        <!-- <th 
                        scope="col"
                        mat-sort-header="type">
                            Type
                        </th> -->

                        
                    </tr>
                </thead>
                <tbody *ngIf="!isLoading && !message">
            
                        <tr *ngFor="let sellIn of sellInData; index as i">
                        
                            <td>{{ sellIn.tp ?? 'N/A' }}</td>
                            <td *ngIf="currentTab == 'dealer'">{{ sellIn.dealer ?? 'N/A' }}</td>
                            <td *ngIf="currentTab == 'subdealer'">{{ sellIn.subdealer ?? 'N/A' }}</td>
                            <td>{{ sellIn.source ?? 'N/A' }}</td>
                            <td>{{ sellIn.source_user_lavel ? globalservice.userLevelTransition(sellIn.source_user_lavel) : 'N/A' }}</td>
                            <td>{{ sellIn.target ?? 'N/A' }}</td>
                            <td>{{ sellIn.target_user_level ? globalservice.userLevelTransition(sellIn.target_user_level) : 'N/A' }}</td>
                            <td>₱{{ globalservice.numberWithCommas(sellIn.amount)}}</td>
                            <td>{{ globalservice.dateToString(sellIn.transaction_date) }}</td>
                            <td>
                                <button 
                                    class="view-details-btn"
                                    (click)="onClickRow(sellIn)">
                                    View
                                </button>
                            </td>
                        </tr>
                
                    </tbody>

                <div 
                *ngIf="message && !isLoading" 
                class="m-auto error-message"><span>{{message}}</span></div>

                <div 
                *ngIf="isLoading" class="table-spinner-div">
                    <span class="sr-only"> <div class="spinner-border" role="status"> </div> Loading...</span>
                </div>

            </table>
        </div>

        <div 
        *ngIf="isMobile"
        class="card-list">
            
            <div *ngIf="!isLoading && !message">
                <tr *ngFor="let sellIn of sellInData; index as i">
                    <div class="items-card">
                        <span><span class="label">Dealer: </span>{{ sellIn.dealer_username }}</span>
                        <span><span class="label">Territorial Partner: </span>{{ sellIn.tp_username }}</span>
                        <span><span class="label">Product Code: </span>{{ sellIn.code }}</span>
                        <span><span class="label">Amount: </span>₱{{ globalservice.numberWithCommas(sellIn.amount) }}</span>
                        <span><span class="label">Date: </span>{{ sellIn.create_date }}</span>
                    </div>
                </tr>
            </div>

            <div *ngIf="message && !isLoading" class="m-auto error-message"><span>{{message}}</span></div>

            <div *ngIf="isLoading" class="table-spinner-div">
                <span class="sr-only"> <div class="spinner-border" role="status"> </div> Loading...</span>
            </div>

        </div>

        <app-sellin-detail-modal/>